<ng-content></ng-content>
<app-svg-icon
    class="icon"
    [src]="'icons/24/arrow-right.svg'"
    [svgStyle]="{ 'width.px': '24', 'height.px': '24' }"
></app-svg-icon>
